import React from 'react';
import '../App.css';

function Skills() {
    return (
        <section id="skills">
            <h2>Skills</h2>
            <ul>
                <li>Java</li>
                <li>Python</li>
                <li>Spring Boot</li>
                <li>Django</li>
                <li>Machine Learning</li>
            </ul>
        </section>
    );
}

export default Skills;
